module.exports = __webpack_public_path__ + "img/back04_sp.c7411606.jpg";